import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {
  MatButtonModule,
  MatCardModule,
  MatDialogModule,
  MatGridListModule,
  MatSliderModule,
  MatSnackBarModule,
  MatTabsModule
} from '@angular/material';
import {MatListModule} from '@angular/material/list';
// Not using barrel to prevent circular dependencies
import {FooterComponent} from './components/footer/footer.component';
import {IndexDotComponent} from './components/index-dot/index-dot.component';
import {NegativeConfirmComponent} from './components/negative-confirm/negative-confirm.component';
import {PositiveConfirmComponent} from './components/positive-confirm/positive-confirm.component';
import {InviteInputComponent} from './components/invite-input/invite-input.component';

import {NamizePipe} from './pipes/namize.pipe';
import {TemperatureConverterPipe} from './pipes/temperature-converter.pipe';
import {SensorConditionPipe} from './pipes/sensor-condition.pipe';
import {SensorHeaderPipe} from './pipes/sensor-header.pipe';
import {SensorUnitPipe} from './pipes/sensor-unit.pipe';
import {KeysPipe} from './pipes/keys.pipe';
import {ObjArraySortPipe} from './pipes/obj-array-sort.pipe';
import {SensorColorPipe} from './pipes/sensor-color.pipe';
import {DeviceTypeNamePipe} from './pipes/device-type-name.pipe';

import {ScrollPreventDirective} from './directives/scroll-prevent.directive';
import {EnumToArrayPipe} from './pipes/enum-to-array.pipe';
import {ScoreToColorPipe} from './pipes/score-to-color.pipe';
import {IndexToColorPipe} from './pipes/index-to-color.pipe';
import {ScoreDotComponent} from './components/score-dot/score-dot.component';
import {SwitchModule} from '../vision/switch/switch.module';
import {SnapshotComponent} from './components/snapshot/snapshot.component';
import {ScoreToConditionPipe} from './pipes/score-to-condition.pipe';
import {DeviceTypeNameFullPipe} from './pipes/device-type-name-full.pipe';
import {LoadingComponent} from './components/loading/loading.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SwitchModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatCardModule,
    MatGridListModule,
    MatListModule,
    MatDialogModule,
    MatButtonModule,
    MatTabsModule,
    MatSnackBarModule,
    MatSliderModule,
    FooterComponent,
    PositiveConfirmComponent,
    NegativeConfirmComponent,
    IndexDotComponent,
    InviteInputComponent,
    NamizePipe,
    TemperatureConverterPipe,
    SensorHeaderPipe,
    SensorUnitPipe,
    SensorConditionPipe,
    SensorColorPipe,
    KeysPipe,
    ObjArraySortPipe,
    DeviceTypeNamePipe,
    ScrollPreventDirective,
    EnumToArrayPipe,
    ScoreToColorPipe,
    IndexToColorPipe,
    SnapshotComponent,
    ScoreToConditionPipe,
    DeviceTypeNameFullPipe,
    LoadingComponent,
    ScoreDotComponent,
  ],
  declarations: [
    FooterComponent,
    PositiveConfirmComponent,
    NegativeConfirmComponent,
    IndexDotComponent,
    InviteInputComponent,
    NamizePipe,
    TemperatureConverterPipe,
    SensorHeaderPipe,
    SensorUnitPipe,
    SensorConditionPipe,
    KeysPipe,
    ObjArraySortPipe,
    SensorConditionPipe,
    SensorColorPipe,
    DeviceTypeNamePipe,
    ScrollPreventDirective,
    EnumToArrayPipe,
    ScoreToColorPipe,
    IndexToColorPipe,
    ScoreDotComponent,
    SnapshotComponent,
    ScoreToConditionPipe,
    DeviceTypeNameFullPipe,
    LoadingComponent
  ],
  entryComponents: [
    PositiveConfirmComponent,
    NegativeConfirmComponent
  ]
})

export class SharedModule {
}

